<!--
 * @Description: file content
 * @Author: liujunyao
 * @Date: 2022-04-22 11:44:44
 * @LastEditors: guozhixion xiaoguo4072@163.com
 * @LastEditTime: 2022-05-09 16:05:47
 * @FilePath: /privacy-web/src/views/PrivacyManage/ProductPrivacy.vue
-->
<template>
  <div class="product-privacy-main" :class="{ 'product-privacy-main-mobile': isMobile }">
    <!-- <Base-title title="产品中的隐私保护"></Base-title> -->
    <div class="product-privacy-content">
      <div
        class="item"
        v-for="item in dataList"
        :key="item.key"
        :style="{ backgroundImage: `url(${item.productLogo})` }"
        @click="productType(item.productName)"
      ></div>
    </div>
  </div>
</template>
<script>
export default {
  // 产品中的隐私保护
  name: "ProductPrivacy",
  data() {
    return {
      dataList: [
        {
          bgImage: require("@/assets/images/homePage/product-beike.png"),
          key: "beike",
          name: "贝壳",
        },
        {
          bgImage: require("@/assets/images/homePage/product-lianjia.png"),
          key: "lianjia",
          name: "链家",
        },
        {
          bgImage: require("@/assets/images/homePage/product-beiwo.png"),
          key: "beiwo",
          name: "被窝",
        },
      ],
    };
  },
  methods: {
    productType(value) {
      this.$store.commit("app/CHANGE_TYPE", value);
    },
  },
  async created() {
    this.readDictByKey("privacyAdminGuide", (res) => {
      this.dataList = res.list.item;
    });
  },
};
</script>
<style lang="scss" scoped>
.product-privacy-main {
  display: flex;
  align-items: center;
  width: 100%;
  flex-direction: column;
}
.product-privacy-content {
  display: flex;
  margin-top: calc($multiple * 69px);

  .item {
    width: calc($multiple * 228px);
    height: calc($multiple * 108px);
    background-repeat: no-repeat;
    background-size: 100%;
    cursor: pointer;
  }
  .item:nth-child(2) {
    margin: 0 calc($multiple * 30px);
  }
}
.product-privacy-main-mobile {
  .product-privacy-content {
    display: flex;
    margin-top: 1.35rem;
    .item {
      margin: 0 0.28rem;
      width: 5.38rem;
      height: 2.61rem;
      background-repeat: no-repeat;
      background-size: 100%;
    }
  }
}
</style>
